<template>
  <div>
    <label class="block">
      <span class="text-gray-700">Textarea</span>
      <textarea
        class="form-textarea mt-1 block w-full"
        rows="3"
        placeholder="Enter some long form content."
      ></textarea>
    </label>
  </div>
</template>

<script>
export default {
  name: "Textarea",
  components: {},
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>